var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Fragment',[(_vm.isSummary)?_c('Side'):_vm._e(),(_vm.isComponent)?_c(_vm.isComponent,{tag:"component"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }